/* OK Daddy: price display only. Native theme still owns cart mutations. */
(() => {
  'use strict';
  if (window.OKDaddyMinicartDisplay) return;
  window.OKDaddyMinicartDisplay = true;
  const variants = new WeakMap();
  let frame, layoutFrame, readTimer, requestNumber = 0, pendingController;
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style:'currency', currency:currency || window.Shopify?.currency?.active || 'INR',
        minimumFractionDigits:2, maximumFractionDigits:2
      }).format(Number(cents) / 100);
    } catch { return `${currency || ''} ${(Number(cents) / 100).toFixed(2)}`.trim(); }
  }
  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }
  function updateEdit(root) {
    let data = variants.get(root);
    if (!data) {
      try { data = JSON.parse(root.querySelector('variant-radios-quick-edit script[type="application/json"]').textContent); }
      catch { data = []; }
      variants.set(root, data);
    }
    const picker = root.querySelector('variant-radios-quick-edit');
    const choices = picker ? [...picker.querySelectorAll('fieldset')].map(fieldset => fieldset.querySelector('.option-swatch-js.active')?.dataset.value) : [];
    const input = root.querySelector('input[name="quantity"]');
    const quantity = Number(input?.value || 1);
    const id = root.querySelector('input[name="id"]')?.value;
    const variant = choices.length && choices.every(Boolean)
      ? data.find(item => item.options.every((value, index) => String(value) === choices[index]))
      : data.find(item => String(item.id) === String(id));
    const output = root.querySelector('[data-od-edit-total]');
    if (variant && Number.isInteger(quantity) && quantity >= 1) {
      setText(output, `Estimated total: ${money(variant.price * quantity, root.dataset.odCurrency)} (${quantity} × ${money(variant.price, root.dataset.odCurrency)})`);
    } else if (picker) {
      setText(output, 'Choose an available size and valid quantity.');
    } else if (Number.isInteger(quantity) && quantity >= 1) {
      const unit = Number(root.dataset.odDefaultPrice);
      if (Number.isFinite(unit)) setText(output, `Estimated total: ${money(unit * quantity, root.dataset.odCurrency)} (${quantity} items)`);
    }
  }
  function fitPopup() {
    cancelAnimationFrame(layoutFrame);
    layoutFrame=requestAnimationFrame(()=>{
      document.querySelectorAll('.minicart .popup_cart.open').forEach(popup=>{
        const available=Math.max(140, window.innerHeight-Math.max(12,popup.getBoundingClientRect().top)-12);
        const limit=`${Math.floor(available)}px`;
        if (popup.style.maxHeight!==limit) popup.style.maxHeight=limit;
      });
    });
  }
  window.addEventListener('resize', fitPopup, {passive:true});
  function prepareEditPopups() {
    // Some themes load the section's inner HTML; also support the original popup.
    document.querySelectorAll('[data-template-quick-cart-edit]').forEach(container=>{
      const root=container.querySelector('product-form-quick-edit') || container;
      if (container!==root && container.hasAttribute('data-od-quick-edit')) {
        for (const key of ['odCurrency','odDefaultPrice']) if (container.dataset[key]) root.dataset[key]=container.dataset[key];
        container.removeAttribute('data-od-quick-edit');
      }
      root.setAttribute('data-od-quick-edit','');
      if (!root.dataset.odCurrency) root.dataset.odCurrency=window.Shopify?.currency?.active || 'INR';
      const price=root.querySelector('.product__price');
      if (price && !root.querySelector('[data-od-edit-total]')) {
        const total=document.createElement('p'); total.className='od-mini-edit-total';
        total.setAttribute('data-od-edit-total',''); total.setAttribute('role','status'); total.setAttribute('aria-live','polite');
        price.after(total);
      }
    });
  }
  function scheduleEdit() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      prepareEditPopups();
      document.querySelectorAll('[data-od-quick-edit]').forEach(updateEdit);
    });
  }
  function optimisticTotal(input) {
    const row = input.closest('[data-od-cart-key]');
    const quantity = Number(input.value);
    if (!row || !Number.isInteger(quantity) || quantity < 0) return;
    setText(row.querySelector('[data-od-line-total]'), `Updating total: ${money(Number(row.dataset.odUnitCents) * quantity, row.dataset.odCurrency)}`);
  }
  // Read the server's actual line totals AFTER native cart updates finish.
  // This respects line-level and quantity-dependent discounts, and never submits a cart change.
  function reconcileCart(attempt = 0) {
    clearTimeout(readTimer);
    readTimer = setTimeout(async () => {
      if (document.querySelector('.header__minicart.loading')) {
        if (attempt < 40) reconcileCart(attempt + 1);
        return;
      }
      const number = ++requestNumber;
      pendingController?.abort();
      pendingController = new AbortController();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {credentials:'same-origin', cache:'no-store', signal:pendingController.signal});
        if (!response.ok) return;
        const cart = await response.json();
        if (number !== requestNumber) return;
        document.querySelectorAll('.minicart [data-od-cart-key]').forEach(row => {
          const item = cart.items.find(item => item.key === row.dataset.odCartKey);
          if (!item) return;
          const input = row.querySelector('input[name="updates[]"]');
          // A newer unsaved user change must not be replaced by an older response.
          if (input && Number(input.value) !== item.quantity) return;
          row.dataset.odUnitCents = String(item.final_price);
          setText(row.querySelector('[data-od-line-total]'), `Total: ${money(item.final_line_price, cart.currency || row.dataset.odCurrency)}`);
        });
      } catch (error) { if (error.name !== 'AbortError') console.warn('OK Daddy: total will refresh with the cart.', error); }
    }, attempt ? 150 : 600);
  }
  document.addEventListener('input', event => {
    if (event.target.closest('[data-od-quick-edit]')) scheduleEdit();
  });
  document.addEventListener('change', event => {
    if (event.target.closest('[data-od-quick-edit]')) scheduleEdit();
    if (event.target.matches('.minicart input[name="updates[]"]')) {
      requestNumber++; pendingController?.abort(); optimisticTotal(event.target); reconcileCart();
    }
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-od-quick-edit]')) scheduleEdit();
    const edit = event.target.closest('[data-od-quick-edit]');
    const quantityButton = event.target.closest('quantity-input button');
    if (edit && quantityButton) {
      // Do not double-step the native quantity component; only refresh the display.
      scheduleEdit();
    }
  });
  document.addEventListener('keydown', event => {
    const edit = event.target.closest('minicart-item-edit[role="button"]');
    if (edit && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); edit.click(); }
  });
  const observer = new MutationObserver(records => {
    if (records.some(record => record.target.nodeType===1 && record.target.closest('.minicart'))) fitPopup();
    if (records.some(record => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      return target?.closest('[data-od-quick-edit], [data-template-quick-cart-edit]') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-od-quick-edit], [data-template-quick-cart-edit]') || node.querySelector('[data-od-quick-edit], [data-template-quick-cart-edit]')));
    })) scheduleEdit();
  });
  observer.observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['class','value','disabled']});
  scheduleEdit();
})();
